import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import TableCell from '../ReusableComponents/Table/TableCell';
import TableRow from '../ReusableComponents/Table/TableRow';

function VendorGradeRow(props) {
  const {
    vendor: { company_name, grade, grade_updated_at },
  } = props;

  return (
    <TableRow>
      <TableCell scope="row" align="center">
        {company_name}
      </TableCell>
      <TableCell padding="normal" align="center">
        {grade}
      </TableCell>
      <TableCell padding="normal" align="center">
        {grade_updated_at && moment(grade_updated_at).format('MM-DD-YYYY')}
      </TableCell>
    </TableRow>
  );
}

VendorGradeRow.propTypes = {
  vendor: PropTypes.shape({}).isRequired,
};

export default VendorGradeRow;
